export class SpecificationCharacteristic {

  id!: string;
  key!: string;
  value!: string;
  tags!: string[];

}
